import auth from "../../auth";
export default {
  data() {
    return {
      client: false,
    };
  },
  created() {
    this.client = auth.getUser().isClient;
  },
  computed: {
    disabled() {
      return this.client;
    },
    allowVisible() {
      return this.client;
    },
  },
};
